//Plantilla de archivo de store
const namespaced = true
import _ from 'lodash';
import api from '../../../api/catalogs/productions_lines.js';

const state = {
    lines: [],
    new_line: [],
    loadingLines: false,
}
const mutations = {
    SET_LINE(state, data) {
        state.lines = data;
    },
    ADD_LINE(state, value) {
        state.lines.push(value);
    },
    SET_NEW_LINE(state, value) {
        state.new_line = value;
    },
    SET_LOADING_LINE(state, data) {
        state.loadingLines = data;
    },
    UPDATE_LINE(state, value) {
        const newArr = _.clone(state.lines);
        const index = _.findIndex(state.lines, function (o) { return o.id == value.id });
        if (index !== -1) {
            newArr[index] = value;
        }
        state.lines = newArr
    },
    DELETE_LINE(state, value) {
        state.lines.splice(_.findIndex(state.lines, function (o) { return o.id == value }), 1)
    },
}
const actions = {
    indexLines(context, data) {
        context.commit('SET_LOADING_LINE', true);
        return new Promise((resolve) => {
            api.indexLines(data).then(function (res) {
                context.commit('SET_LINE', res.data.data);
                resolve(res);
                context.commit('SET_LOADING_LINE', false);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_LINE', false);
            })
        })
    },
    storeLines(context, data) {
        context.commit('SET_LOADING_LINE', true);
        return new Promise((resolve) => {
            api.storeLines(data).then(function (res) {
                context.commit('SET_NEW_LINE', res.data.data);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
                resolve(res);
                context.commit('SET_LOADING_LINE', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_LINE', false);
            })
        })
    },
    updateLines(context, data) {
        context.commit('SET_LOADING_LINE', true);
        return new Promise((resolve) => {
            api.updateLines(data.id, data.data).then(function (res) {
                context.commit('SET_NEW_LINE', res.data.data);
                context.dispatch('notifications/add', { 'color': 'success', 'visibility': true, 'timeout': 5000, 'text': res.data.message }, { root: true });
                resolve(res);
                context.commit('SET_LOADING_LINE', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_LINE', false);
            })
        })
    },
    deleteLines(context, id) {
        return new Promise((resolve) => {
            api.deleteLines(id).then(function (res) {
                context.commit('SET_NEW_LINE', res.data.data);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
            }).catch(function (error) {
                console.log(error)
            })
        })
    },
}
const getters = {
    getStateLines(state) {
        return state.lines;
    },
    getNewLine(state) {
        return state.new_line;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}